"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale } from "next-intl";
import { useAudience } from "@/components/common/audience";
import { useNavigationState } from "@/components/navigation/navigation-provider";
import type { Locale } from "@/i18n/config";
import { getLocalizedSlug, type LocalizedSlug } from "@/lib/routing/url-builder";

/** Slug for the configured business home page, or null when unset. */
export function useBusinessHomeHref() {
  const $ = _c(3);
  const {
    navigationData
  } = useNavigationState();
  const locale = useLocale() as Locale;
  const t0 = navigationData.businessHomePage as LocalizedSlug | null;
  let t1;
  if ($[0] !== locale || $[1] !== t0) {
    t1 = getLocalizedSlug(t0, locale);
    $[0] = locale;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/** Logo destination: the business home page while in business mode, else "/". */
export function useHomeHref() {
  const {
    activeTab
  } = useAudience();
  const businessHomeHref = useBusinessHomeHref();
  return activeTab === "businesses" && businessHomeHref ? businessHomeHref : "/";
}